module.exports = __webpack_public_path__ + "d1b55956e36a2dce6f928e16b7c35fdf.png";